import { render, staticRenderFns } from "./productSourceTable.vue?vue&type=template&id=b3f6ea2a&"
import script from "./productSourceTable.vue?vue&type=script&lang=js&"
export * from "./productSourceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports